import React, { Component } from "react";

import ListOfQuestion from "./list_of_question";
import ListQuestionPage from "./interface/page_question/list_question_page";
import ListUser from "./interface/list_user";
import ListFinished from "./interface/list_finished";

import { Link } from "react-router-dom";

import { startList } from "../../helper/list_helper";

import SharingInviteView from "../share/sharing_invite_view";

import Conditions from "./interface/winner/conditions";
import MoreInfo from "./interface/winner/more_info";

import LocalizedStrings from "react-localization";
import en from "../../localization/localization-en.json";
let strings = new LocalizedStrings({ en });

class ListOfQuestionPage extends Component {
  state = { currentQuestion: null };

  render() {
    if (this.props.list.already_comment === true) {
      return (
        <ListOfQuestion
          list={this.props.list}
          addAnswer={this.props.addAnswer}
          removeAnswer={this.props.removeAnswer}
          updateAnswer={this.props.updateAnswer}
          history={this.props.history}
          user={this.props.user}
        />
      );
    }

    if (this.state.currentQuestion === null) {
      return (
        <div className="profilePage page_top_nav list center">
          <div className="max_width_500">
            <ListUser
              user={this.props.user}
              list={this.props.list}
              questionNumber={this.props.list.question_number}
              history={this.props.history}
            />
            <MoreInfo list={this.props.list} />
            {this.renderButton()}
          </div>
        </div>
      );
    } else {
      const question = this.props.list.questions[this.state.currentQuestion];
      if (typeof question !== "undefined") {
        return (
          <div className="profilePage page_top_nav list center list_question">
            <div className="max_width_500">
              <ListQuestionPage
                list={this.props.list}
                nextQuestion={this.nextQuestion}
                question={question}
                currentQuestion={this.state.currentQuestion}
                questionNumber={this.props.list.question_number}
                addAnswer={this.props.addAnswer}
                handlerPreviousQuestion={this.handlerPreviousQuestion}
              />
              {this.renderButton()}
            </div>
          </div>
        );
      } else {
        return (
          <ListFinished
            list={this.props.list}
            seeAnswers={this.props.seeAnswers}
            history={this.props.history}
            user={this.props.user}
            invite_giveaway={this.props.invite_giveaway}
          />
        );
      }
    }
  }

  renderButton() {
    if (this.props.user == null) {
      // Render Sign In
      const signInUrl = "/sign_in?list=" + this.props.list.name;
      const signupUrl = "/sign_up?list=" + this.props.list.name;
      return (
        <div className="fixed-bottom pb-3">
          <div
            className="max_width_500"
            style={{ width: "80%", display: "inline-block" }}
          >
            <Link to={signInUrl}>
              <button
                className="btn btn_primary btn_yaystack btn_next mr-2"
                style={{
                  width: "calc(50% - 5px)",
                  marginRight: "5px !important"
                }}
              >
                {strings.sign_in}
              </button>
            </Link>
            <Link to={signupUrl}>
              <button
                className="btn btn_primary btn_yaystack btn_next "
                style={{
                  width: "calc(50% - 5px)",
                  marginRight: "5px !important"
                }}
              >
                {strings.sign_up}
              </button>
            </Link>
          </div>{" "}
        </div>
      );
    }
    if (this.state.currentQuestion === null) {
      if (this.props.list.give_away) {
        if (
          this.props.list.give_away.min_followers >
          this.props.list.give_away.user_followers
        ) {
          return (
            <div className="fixed-bottom pb-3">
              <div
                className="btn_skip"
                style={{
                  fontFamily: "DIN Pro Bold",
                  textTransform: "capitalize"
                }}
              >
                You need {this.props.list.give_away.min_followers} followers to
                enter this giveaway
              </div>
              <div
                className="btn btn_primary btn_yaystack btn_next max_width_500"
                style={{ width: "50%" }}
                onClick={this.handlerInviteFriend}
              >
                Invite Friends
              </div>
              {this.renderShareView()}
            </div>
          );
        }
      }
      return (
        <div className="fixed-bottom pb-3">
          {/* <label
            style={{}}
            onClick={this.props.seeAnswers}
            className="cursor_btn btn_skip"
          >
            SEE ANSWERS
          </label> */}
          <button
            className="btn btn_primary btn_yaystack btn_next max_width_500"
            style={{ width: "50%" }}
            onClick={this.startQuestion}
          >
            START
          </button>
          <Conditions list={this.props.list} />
        </div>
      );
    }
  }

  renderShareView() {
    if (this.state.showSharingView) {
      return (
        <SharingInviteView
          handlerInviteFriend={this.handlerInviteFriend}
          username={this.props.user.username}
        />
      );
    }
  }

  handlerInviteFriend = e => {
    const openMenu = false;
    const showSharingView = !this.state.showSharingView;
    this.setState({ openMenu, showSharingView });
  };

  startQuestion = event => {
    event.preventDefault();

    var startListCall = startList(this.props.list.name);
    startListCall.promise.then().catch();

    var currentQuestion = 0;
    for (var i = 0; i < this.props.list.questions.length; i++) {
      if (this.props.list.questions[i].already_comment === false) {
        currentQuestion = i;
        break;
      }
    }
    this.setState({ currentQuestion });
  };

  skip = event => {
    event.preventDefault();
    const currentQuestion = this.props.list.questions.length;
    this.setState({ currentQuestion });
  };

  nextQuestion = event => {
    const currentQuestion = this.state.currentQuestion + 1;
    //if (currentQuestion > this.props.list.questions.length - 1) {
    //  this.props.reloadList();
    //}
    this.setState({ currentQuestion });
  };

  handlerPreviousQuestion = event => {
    var currentQuestion = this.state.currentQuestion - 1;
    if (currentQuestion < 0) {
      currentQuestion = 0;
    }
    this.setState({ currentQuestion });
  };
}

export default ListOfQuestionPage;



// WEBPACK FOOTER //
// ./src/components/list/list_of_question_page.jsx